import Image from 'next/image';
import {
  BearsNotFound,
  Gif,
  Subtitle,
  Title,
} from '@/scenes/Gallery/404/styles';
import BearsNotFoundGif from '@/assets/BearsNotFound.gif';

const GalleryNotFound = () => {
  return (
    <BearsNotFound>
      <Title>Ooops...</Title>
      <Subtitle>No results for selected categories</Subtitle>
      <Gif>
        <Image src={BearsNotFoundGif} />
      </Gif>
    </BearsNotFound>
  );
};

export default GalleryNotFound;
